AccountPersonalController.$inject = ['CONST', 'User', 'API', '_', 'alerts', 'Club'];

/* @ngInject */
function AccountPersonalController(CONST, User, API, _, alerts, Club) {
    var vm = this;
    vm.title = 'AccountPersonalController';

    var user = User.data;

    vm.loading = {
        all: false,
        info: false,
        avatar: false
    };

    vm.info = {
        name: user.name,
        email: user.email,
        phone: user.phone
    };

    vm.save_info = function () {
        alerts.code(null,null,User).then(save_info);
        // alerts.code().then(save_info);
    };

    activate();

    ////////////////

    function activate() {
        vm.loading.all = true;
        API.one('account').get().then(function (res) {
            update_vm(res);
            vm.loading.all = false;
        });
    }

    function save_info(code) {
        vm.loading.info = true;
        var data = info_formatData(code);

        Club.API.one('account')
        // API.one('account')
            .customPUT(data)
            .then(function () {
                alerts.success('¡Exito!', 'Se actualizaron tus datos personales con éxito');
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.info = false;
            });
    }

    function info_formatData(code) {
        return {
            name: vm.info.name,
            phone: vm.info.phone,
            code: code
        };
    }

    function update_vm(data) {
        var i = vm.info;
        i.name = data.name;
        i.email = data.email;
        i.phone = data.phone;
    }
}

export default AccountPersonalController;
